import React from 'react'
import axios from 'axios'
import Fade from 'react-reveal/Fade';
// MUI
import { makeStyles } from '@material-ui/core/styles';
import {
    Avatar,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListSubheader,
    Typography,
    Card,
    Icon,
    CardActions, 
    CardContent,
    Button,
    GridList,
    Chip,
    Grid,
    Slide,
    Dialog,
    AppBar,
    Toolbar,
    Fab,
    Divider,
    Link,
    SvgIcon,
    Paper,
    IconButton,
  } from '@material-ui/core';


function Home() {
    const style = makeStyles((theme) => ({
        root: {
            marginTop:'100%'
        },
        card: {
          minWidth: 100,
          margin: 40,
          marginBottom:50,
          marginTop:'100%',
          marginRight:'20%'
        },
        TextStyle: {
            textAlign: 'center',
            fontWeight: 'bold',
            fontStyle: 'italic',
            fontSize: 20,
            textDecorationLine: 'underline',
            //line-through is the trick
        },
      }));
      // WORLD
      const [wCases, setWCases] = React.useState(0)
      const [wDeaths, setWDeaths] = React.useState(0)
      const [wRecovered, setWRecovered] = React.useState(0)
      // AUS
      const [aCases, setACases] = React.useState(0)
      const [aDeaths, setADeaths] = React.useState(0)
      const [aRecovered, setARecovered] = React.useState(0)
      const [todayCases, setTodayCases] = React.useState(0)
      const [todayDeaths, setTodayDeaths] = React.useState(0)
      const [active, setActive] = React.useState(0)
      const [critical, setCritical] = React.useState(0)
      const [casesPerM, setCasesPerM] = React.useState(0)


      function getAll(){
        axios
            .get('/getWorld')
            .then(res => {
                const wCases = res.data.cases
                const wDeaths = res.data.deaths
                const wRecovered = res.data.recovered
                setWCases(wCases)
                setWDeaths(wDeaths)
                setWRecovered(wRecovered)
            })

    }

    function getAustralia(){
        axios
            .get('/getAustralia')
            .then(res => {
                console.log(res)
                const aCases = res.data.cases
                const aDeaths = res.data.deaths
                const aRecovered = res.data.recovered
                const todayCases = res.data.todayCases
                const todayDeaths = res.data.todayDeaths
                const active = res.data.active
                const critical = res.data.critical
                const casesPerM = res.data.casesPerM
                setACases(aCases)
                setADeaths(aDeaths)
                setARecovered(aRecovered)
                setTodayCases(todayCases)
                setTodayDeaths(todayDeaths)
                setActive(active)
                setCritical(critical)
                setCasesPerM(casesPerM)
            })

    }
    function getCurrentDate(separator=', '){

        let newDate = new Date()
        let date = newDate.getDate();
        let year = newDate.getFullYear();

        const monthNames = ["January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"
                            ];

        return `${date}${separator}${monthNames[newDate.getMonth()]}${separator}${year}`

        }

    React.useEffect(() => {
        getAll()
        getAustralia()
    },[])
      
    return (
        <div className={style.root}>
            
            <Typography variant="h2" gutterBottom style={{alignItems:'center', justifyContent: 'center'}}>
                COVID-19
            </Typography>
            <Typography variant="h6" gutterBottom style={{alignItems:'center', justifyContent: 'center'}}>
                {getCurrentDate()}
            </Typography>
            
            <Grid style={{marginTop:'1%'}}>

                
                <Fade>
                    <Grid>
                    <Card className={style.card}> 
                        <CardContent>
                            <div style={{marginLeft:10}}>
                                <Typography variant='h4'>
                                   World Wide 🌏:
                                </Typography>
                                <div style={{marginLeft:"8%", marginTop:'0.5%'}}>
                                    <Typography variant='h6' style={{color:'#007a16'}}>
                                    😷 Cases: {wCases != 0 ? wCases : 'Loading...'}
                                    </Typography>
                                    <Typography variant='h6' style={{color:'red'}}>
                                    Deaths: {wDeaths != 0 ? wDeaths : 'Loading...'}
                                    </Typography>
                                    <Typography variant='h6' style={{color:'#06007a'}}>
                                    🏥 Recovered: {wRecovered != 0 ? wRecovered : 'Loading...'}
                                    </Typography>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                    </Grid>
                    <Grid style={{marginTop:'2%'}}>
                    <Card className={style.card}> 
                        <CardContent>
                            <div style={{marginLeft:10}}>
                                <Typography variant='h4'>
                                   Australia Wide 🇦🇺:
                                </Typography>
                                <div style={{marginLeft:"8%", marginTop:'0.5%'}}>
                                    <Typography variant='h6' style={{color:'#007a16'}}>
                                    😷 Cases: {aCases != 0 ? aCases : 'Loading...'}
                                    </Typography>
                                    <Typography variant='h6' style={{color:'red'}}>
                                    Deaths: {aDeaths != 0 ? aDeaths : 'Loading...'}
                                    </Typography>
                                    <Typography variant='h6' style={{color:'#06007a'}}>
                                    🏥 Recovered: {aRecovered != 0 ? aRecovered : 'Loading...'}
                                    </Typography>
                                    <Typography variant='h6'>
                                    😷 Today's Cases: {wCases != 0 ? todayCases : 'Loading...'}
                                    </Typography>
                                    <Typography variant='h6'>
                                    Today's Deaths: {wCases != 0 ? todayDeaths : 'Loading...'}
                                    </Typography>
                                    <Typography variant='h6'>
                                    Active: {wCases != 0 ? active : 'Loading...'}
                                    </Typography>
                                    <Typography variant='h6'>
                                    Critical: {wCases != 0 ? critical : 'Loading...'}
                                    </Typography>
                                    <Typography variant='h6'>
                                    Cases per million: {aRecovered != 0 ? aRecovered : 'Loading...'}
                                    </Typography>

                                    
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                    </Grid>
                    
                    </Fade>
                </Grid>
        </div>
    )
}

export default Home
